import { Opportunity } from "./opportunity.model";

export class OpportunitiesSegment {
    constructor(
        public opportunities: Opportunity[] = [],
        public totalOpportunityCount: number = 0
    ) { }
}